import React from 'react';

const Darklight = (props)=> {
    let num = props.num;
    let innerDivs = [];
    for (let i = num; i>=0; i--){
        innerDivs.push(<div key={i} className={`dl-div-${i}`}></div>);
    }
    return (
        <div>
            <div id="darklight" >
                {innerDivs}
            </div>
        </div>   
        )
}

export default Darklight;